import {
  OWNED_TOPIC_TERRITORY_TYPE,
  SEARCH_TERRITORY_COMPARE_GROUPS,
} from './get-search-territory-compare-groups.consts'
import type {
  ISearchTerritoryCompareOption,
  ISearchTerritoryCompareResult,
  ISearchTerritoryResult,
} from './get-search-territory-compare-groups.types'

const getTerritoryType = ({ territoryId }: ISearchTerritoryResult) => territoryId.split('.')[0]

const toCompareOption = ({ territoryId, name }: ISearchTerritoryResult): ISearchTerritoryCompareOption => {
  const [type, ...idParts] = territoryId.split('.')
  return { label: name, value: idParts.join('.'), type }
}

export function getSearchTerritoryCompareGroups<TResult extends ISearchTerritoryResult>(
  territories: readonly TResult[] | undefined
): ISearchTerritoryCompareResult<TResult> {
  const results = territories ?? []
  const taxonomyOptions = results.map(toCompareOption)

  return {
    ownedTopics: results.filter(territory => getTerritoryType(territory) === OWNED_TOPIC_TERRITORY_TYPE),
    taxonomyGroups: SEARCH_TERRITORY_COMPARE_GROUPS.map(({ label, types }) => ({
      label,
      options: taxonomyOptions.filter(option => types.includes(option.type)),
    })).filter(group => group.options.length > 0),
  }
}
